import { HistoryMessageItem, MessageIncomingEvent } from '@wui/im'
import { unix } from 'dayjs'

const DELTA_GROUP_MINUTES = 3

export const isSameMessageAuthor = (
  event?: HistoryMessageItem,
  neighbor?: HistoryMessageItem,
): boolean => {
  if (!event || !neighbor) return false
  if (neighbor.item.type !== event.item.type) return false

  if (
    (neighbor.item.type === 'IncomingMessageEvent' && event.item.type === 'IncomingMessageEvent') ||
    (neighbor.item.type === 'OutgoingMessageEvent' && event.item.type === 'OutgoingMessageEvent')
  ) {
    const neighborFrom = (neighbor.item as MessageIncomingEvent).executor
    const eventFrom = (event.item as MessageIncomingEvent).executor
    if (neighborFrom !== eventFrom) return false
  }

  return true
}

export const isSameMessageSeries = (
  event?: HistoryMessageItem,
  neighbor?: HistoryMessageItem,
): boolean => {
  if (!event?.timestamp || !neighbor?.timestamp) return false
  if (!isSameMessageAuthor(event, neighbor)) return false

  const earlierTimestamp = Math.min(event.timestamp, neighbor.timestamp)
  const laterTimestamp = Math.max(event.timestamp, neighbor.timestamp)
  const dEarlier = unix(earlierTimestamp)
  const dLater = unix(laterTimestamp)

  return (
    dEarlier.isSame(dLater, 'day') &&
    dEarlier.isSame(dLater, 'hour') &&
    dLater.isBefore(dEarlier.add(DELTA_GROUP_MINUTES, 'minutes'))
  )
}
